import { cpqAxios, cpqAxiosWithToken, cpqAxiosWithoutUrlEncoding } from '../http-common';
import axios from 'axios';
import { Congiguration } from '../Constants/AppConstants';

class CommonService {

    getCountryById(id) {
        return cpqAxiosWithToken.get(`/GetCountryById/?id=${id}`);
    }

    getProductDetails() {
        return cpqAxiosWithToken.get("/GetProductDetails");
    }

    sendEmailToStakeHolders(emailParam) {
        return cpqAxiosWithToken.post("/Email/SendEmailToStakeholders", emailParam);
    }

    notifyApproverForBundleApproval(bundleId) {
        return cpqAxiosWithToken.post("/Email/NotifySelectedApprover?bundleId=" + bundleId);
    }
    //NEED TO MOVE THE IMPLEMENTATION TO HTTP-COMMON
    getDecryptedText(encryptedStr) {
        return cpqAxiosWithToken.get(Congiguration.CPQApi + '/EncryptionDecryption/GetDecryptedText', {
            params: {
                'inputDecryptionText': encryptedStr
            },
            paramsSerializer: {
                encode: (param) => encodeURIComponent(param).replaceAll("+", "%2B"),
            }
        });        
    }

    getEncryptedText(str) {
        return cpqAxiosWithToken.post(`/EncryptionDecryption/GetEncryptedText?inputEncryptionText=${str}`);
    }
}

export default new CommonService();